(function () {
    var pluginName = 'navDropdown';

    function navDropdown(selector) {
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;
        this.config = {
            trigger: '[nav-dropdown-trigger]',
            panel: '[nav-dropdown-panel]',
            close: '[nav-dropdown-close]'
        };
        this.trigger = this.selector.querySelector(this.config.trigger);
        this.panel = this.selector.querySelector(this.config.panel);
        //this.closeBtn = this.selector.querySelector(this.config.close);
        this.navPanel = this.selector.querySelector(this.config.panel);
        this.state = {
            open: false
        };
        this.init();
    }

    navDropdown.prototype.init = function init() {
        if (this.selector === null) {
            throw new Error(pluginName + ': fail - something wrong with your selector');
        } else {
            this.bindEvents();
        }
    }

    navDropdown.prototype.bindEvents = function bindEvents() {
        document.addEventListener('click', this.handleDocumentClick.bind(this));
        this.trigger.addEventListener('click', this.handleClick.bind(this));
        // this.closeBtn.addEventListener('click', function(event) {
        //     event.preventDefault();
        //     this.close();
        // }.bind(this));
    }

    navDropdown.prototype.handleDocumentClick = function handleDocumentClick(event) {
        if (!event.target.closest('[nav-dropdown]')) {
            this.close();
        }
    }

    navDropdown.prototype.handleClick = function handleClick(event) {
        event.preventDefault();
        this.state.open = !this.state.open;

        if (this.state.open) {
            this.open();
        } else {
            this.close();
        }
    }

    navDropdown.prototype.open = function open() {
        this.state.open = true;
        this.navPanel.scrollTop = 0;
        this.navPanel.style.overflow = "hidden";
        this.selector.classList.add('is-active');
        this.panel.classList.add('is-active');
    }

    navDropdown.prototype.close = function close() {
        this.state.open = false;
        this.selector.classList.remove('is-active');
        this.panel.classList.remove('is-active');
        this.navPanel.removeAttribute("style");
    }

    // Create instances
    var all = {}, index;
    window.addEventListener('load', function () {
        if (document.querySelectorAll('[nav-dropdown]').length) {
            global.navDropdown = { instances: {} };
            all = document.querySelectorAll('[nav-dropdown]');
            index = -1;
            while (all[++index]) {
                global.navDropdown.instances[index] = new navDropdown(all[index]);
            }
        }
    }, false);

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = navDropdown;
    // Export to Browser
    else global[pluginName] = navDropdown; // eslint-disable-line
}());
